var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "hinava_random_uuid_88717893261795687637063591106684053250",
    cx: 12,
    cy: 12,
    r: 12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_102065507009862365153914875618941588991",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hinava_random_uuid_88717893261795687637063591106684053250"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#hinava_random_uuid_88717893261795687637063591106684053250"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    mask: "url(#hinava_random_uuid_102065507009862365153914875618941588991)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#239F40",
    d: "M0 0H42V24H0z",
    transform: "translate(-9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 8H42V16H0z",
    transform: "translate(-9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA0000",
    d: "M0 16H42V24H0zM22 10s2.578 1.641.683 4c1.785-.888 1.939-3.33-.683-4zM21 9.724c-.445.668-1.21.004-.946-.724.46 1.098.946.21.946.21s.487.888.946-.21c.263.728-.501 1.392-.946.724z",
    transform: "translate(-9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA0000",
    d: "M21 15l-.262-.313s-.619.188-1.433-.072c.667 0 1.04-.107 1.178-.17 0 0-1.512-.743-1.483-2.255.089-1.53.982-1.995.982-1.995s-1.59 2.111.746 3.876l-.103-2.183v-1.604C20.757 10.255 21 10 21 10s.243.255.375.284v1.604l-.103 2.183c2.336-1.765.746-3.876.746-3.876s.893.465.982 1.995c.03 1.512-1.482 2.255-1.482 2.255.137.063.51.17 1.177.17-.814.26-1.433.072-1.433.072L21 15z",
    transform: "translate(-9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA0000",
    d: "M20 10s-2.578 1.641-.683 4c-1.785-.888-1.939-3.33.683-4z",
    transform: "translate(-9)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIr);
export default __webpack_public_path__ + "static/media/ir.332e694152771bc1f79de11f680e87de.svg";
export { ForwardRef as ReactComponent };